__turbopack_context__.v({
  "featuresButton": "features-module-scss-module__YLVJoW__featuresButton",
});
